var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import * as Option from "fp-ts/lib/Option";
import { VideoHeader } from "core/components";
import { config } from "core/utils";
import { VideoRatioHelper } from "core/components/RatioHelper";
import { Content } from "pages/video/Content";
import { mq } from "core/styles/snippets";
export var prepBlock = function (Player) { return function (data) {
    return Option.some({
        key: "videoHeader_".concat(data.uuid),
        View: function () { return (React.createElement(Container, null,
            React.createElement(VideoHeader, null,
                React.createElement(VideoRatioHelper, null,
                    React.createElement(Player, { myChannelsVideo: data.myChannelsVideoId, playerConfig: config.playerConfigForVideoPage })),
                React.createElement(Content, { data: data })))); },
    });
}; };
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 auto;\n  max-width: 120rem;\n  padding: 0 1rem;\n  \n  ", " {\n    padding: 0 1.5rem;\n  }\n\n  ", " {\n    padding: 0 2.5rem;\n  }\n\n  ", " {\n    padding: 0 5rem;\n  }\n"], ["\n  margin: 0 auto;\n  max-width: 120rem;\n  padding: 0 1rem;\n  \n  ", " {\n    padding: 0 1.5rem;\n  }\n\n  ", " {\n    padding: 0 2.5rem;\n  }\n\n  ", " {\n    padding: 0 5rem;\n  }\n"])), mq.minWidth("48rem"), mq.minWidth("64rem"), mq.minWidth("90rem"));
var templateObject_1;
